import {A, action, createAsync, RouteDefinition} from "@solidjs/router";
import {PetResponse} from "@tag-tails/types";
import {FaSolidEye, FaSolidPenToSquare, FaSolidTrash} from "solid-icons/fa";
import {For, Show} from "solid-js";
import {getUser} from "~/api/auth";
import {deletePet, getPetsByOwner} from "~/api/pets";
import btn from "~/css/components/ui/button.module.css"
import icon from "~/css/components/ui/icon.module.css"
import css from "~/css/routes/dashboard/pets.module.css"
import Page from "~/components/Page";
import Container from "~/components/Container";
import Section from "~/components/Section";

const deletePetAction = action(async (id: string) => {
    "use server"
    await deletePet(id)
})

export const route = {
    preload: async () => {
        const user = await getUser()
        if (user) {
            await getPetsByOwner(user.id)
        }
        return user
    }
} satisfies RouteDefinition

export default function PetsPage() {

    const user = createAsync(() => getUser())
    const pets = createAsync<Array<PetResponse> | null>(() => getPetsByOwner(user()?.id!))

    return (
        <Page>
            <Container class={css.header}>
                <h1>Pets</h1>
                <A href="/dashboard/pets/new" class={btn.primarySolid}>New Pet</A>
            </Container>
            <Section>
                <Container>
                    <div class={css.grid}>
                        <p>Name</p>
                        <p>Species</p>
                        <p>Actions</p>
                        <Show when={pets()} keyed>
                            {(pets) => (
                                <For each={pets}>
                                    {(pet) => (
                                        <>
                                            <p>{pet.name}</p>
                                            <p>Dog</p>
                                            <div class={css.actions}>
                                                <A href={`/dashboard/pets/${pet.id}`}><FaSolidPenToSquare/></A>
                                                <A href={`/pet/${pet.id}`}><FaSolidEye/></A>
                                                <form method="post" action={deletePetAction.with(pet.id)}>
                                                    <button><FaSolidTrash class={icon.danger}/></button>
                                                </form>
                                            </div>
                                        </>
                                    )}
                                </For>
                            )}
                        </Show>
                    </div>
                </Container>
            </Section>
        </Page>
    )
}